import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import api from '../../api';
import { useGlobalContext } from '../../context';
import ReactDataTable from '../components/ReactDataTable';
import SideNav from '../components/SideNav';
import adminDashLinks from './adminDashLinks';

import { GiHamburgerMenu } from "react-icons/gi";
import { BiLogOut } from "react-icons/bi";
import ConfirmModal from '../components/ConfirmModal';

const Admintrades = () => {
  const { AllUsersTradeData } = useGlobalContext();
  const [navActive, updateNavActive] = useState(null);
  const [confirm, setConfirm] = useState(null);

  const askConfirm = (title, message, onConfirm, confirmLabel, confirmClass) => {
    setConfirm({ title, message, onConfirm, confirmLabel, confirmClass });
  };

  const clearSess = async () => {
    try { await api.post('/api/logout'); } catch (e) {}
    window.sessionStorage.clear();
  };

  const hideNav = () => updateNavActive(false);

  useEffect(() => {
    if (navActive) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [navActive]);

  const completeTrade = async (userId) => {
    try {
      const response = await api.post('/api/admin/completetrade', { userId });
      const responseData = response.data;
      if (responseData.errMsg) { toast.error(responseData.errMsg); }
      else { toast.success(responseData.successMsg); setTimeout(() => window.location.reload(), 5000); }
    } catch (error) { console.log(error); }
  };

  const deleteTrade = async (userId) => {
    try {
      const response = await api.post('/api/admin/deleteTrade', { userId });
      const responseData = response.data;
      if (responseData.errMsg) { toast.error(responseData.errMsg); }
      else { toast.success(responseData.successMsg); setTimeout(() => window.location.reload(), 5000); }
    } catch (error) { console.log(error); }
  };

  const columns = [
    {
      name: 'Date',
      selector: (row) => row.tradedate,
      cell: (row) => <div style={{ whiteSpace: 'normal' }}>{new Date(row.tradedate).toLocaleDateString('en-GB')}</div>,
    },
    {
      name: 'Email',
      selector: row => row.useremail,
      cell: (row) => <div style={{ whiteSpace: 'normal' }}>{row.useremail}</div>,
    },
    {
      name: 'Amount',
      selector: row => row.tradeamount,
      cell: (row) => <div style={{ whiteSpace: 'normal' }}>${parseFloat(row.tradeamount).toLocaleString()}</div>,
    },
    {
      name: 'Plan',
      selector: row => row.tradeplan,
      cell: (row) => <div style={{ whiteSpace: 'normal' }}>{row.tradeplan}</div>,
    },
    {
      name: 'Status',
      selector: row => row.tradestatus,
      cell: (row) => <div style={{ whiteSpace: 'normal' }}>{row.tradestatus}</div>,
    },
    {
      name: 'Action',
      cell: (row) => (
        <div style={{ whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <button onClick={() => askConfirm('Delete Trade', 'Delete this trade record?', () => deleteTrade(row._id))} className="bg-red-700 text-white flex justify-center items-center min-w-[60px] h-[28px] rounded-lg px-2 text-[12px]">Delete</button>
          <button onClick={() => askConfirm('Complete Trade', `Mark this trade for ${row.useremail} as complete? This will pay out the principal and profit.`, () => completeTrade(row._id), 'Complete', 'bg-green-700 hover:bg-green-800')} className="bg-green-700 text-white flex justify-center items-center min-w-[60px] h-[28px] rounded-lg px-2 text-[12px]">Complete</button>
        </div>
      ),
    },
  ];

  return (
    <div className="absolute overflow-x-hidden w-full min-h-full text-white bg-black">
      <SideNav
        hideNav={hideNav}
        logout="/signin"
        logoutBtn={clearSess}
        translateAction={navActive ? `translate-x-[0px]` : `translate-x-[-500px]`}
        backgroundColor="bg-black"
        iconBorderColor="border-black"
        iconBgColor="bg-inherit"
        textColor="text-white"
        links={adminDashLinks}
        logouticon={
          <BiLogOut className="cursor-pointer text-[20px] text-white transition-all ease-in duration-300 hover:scale-[1.1]" />
        }
      />

      {navActive && (
        <div className="fixed inset-0 bg-black/60 z-40 xl:hidden" onClick={hideNav} />
      )}

      {confirm && (
        <ConfirmModal
          title={confirm.title}
          message={confirm.message}
          confirmLabel={confirm.confirmLabel}
          confirmClass={confirm.confirmClass}
          onConfirm={() => { confirm.onConfirm(); setConfirm(null); }}
          onCancel={() => setConfirm(null)}
        />
      )}

      <div className="relative flex flex-col flex-grow w-full h-full px-4 mb-[100px] xl:pl-[304px] xl:pr-6">
        {/* top nav */}
        <nav className="relative w-full min-h-[100px] flex justify-center items-start pt-3">
          <div className="relative w-full min-h-[50px] flex justify-between items-center xl:justify-end">
            <button onClick={() => updateNavActive(true)} className="relative xl:hidden">
              <GiHamburgerMenu className="text-[20px] text-[#A9ABAD]" />
            </button>
          </div>
        </nav>

        {/* page header */}
        <div className="relative w-full flex flex-col justify-start items-start space-y-1 pt-4 pb-8">
          <h3 className="text-[20px] font-[600] text-white">Manage Trades</h3>
          <p className="text-[#A9ABAD] text-[14px]">View, complete, or delete user trades.</p>
        </div>

        {/* table */}
        <div className="relative w-full overflow-x-auto">
          <ReactDataTable columns={columns} data={AllUsersTradeData} />
        </div>
      </div>
    </div>
  );
};

export default Admintrades;
